<div class="contentMiddle">
  <div>
    <span class="headingMiddle">Choose your change type</span>
  </div>
  <div class="contentButton">
    <button id="btn1" class="selectbtn" (click)="searchTypeChanged('JobPlan')"
      [ngClass]="{ activebtn: searchType == 'JobPlan' }">
      Job Plan
    </button>
    <button id="btn1" class="selectbtn" (click)="searchTypeChanged('MWO')"
      [ngClass]="{ activebtn: searchType == 'MWO' }">
      MWO Header
    </button>
    <button id="btn1" class="selectbtn" (click)="searchTypeChanged('PM')" [ngClass]="{ activebtn: searchType == 'PM' }">
      PM
    </button>
    <button id="btn1" class="selectbtn" (click)="searchTypeChanged('EPL')"
      [ngClass]="{ activebtn: searchType == 'EPL' }">
      EPL
    </button>
  </div>
</div>

<div class="SearchSection">
  <div class="searchBlock">
    <div class="cardUi w-100" [ngClass]="{'fieldBlock': isEPLShow}">
      <span class="headingMiddle">Enter your search criteria</span>
      <form [formGroup]="searchForm" (ngSubmit)="search()" #myForm="ngForm">
        <div class="inputlist">
          <div class="textboxList">
            <div class="inputbox">
              <p>
                Tag/s
                <span #pmtag>
                  <fa-icon [icon]="iconPack.FASEARCHPLUS" (click)="openPopupCheck(pmtag, pmTagText, 'tag')"
                    class="faIcon"></fa-icon>
                </span>
              </p>
              <input type="text" value="" #pmTagText formControlName="tag" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isMWOShow">
              <p>
                MWO<span #pmMwo><fa-icon [icon]="iconPack.FASEARCHPLUS"
                    (click)="openPopupCheck(pmMwo, pmMWOText, 'mwo')" class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value="" #pmMWOText formControlName="mwo" [ngClass]="{'field-mandatory':mwoInputError}" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isMWOProbDescShow">
              <p>MWO Problem Description</p>
              <input
                     type="text"
                     formControlName="mwoProblemDescription"
                     (keydown)="OnKeyDown($event)"
                     [placeholder]="searchType === 'PM' ? 'Contains search using *..' : ''" />
            </div>

            <div class="inputbox" *ngIf="isJPNumberShow">
              <p>
                Job Plan Number<span #JobPlanNumber><fa-icon [icon]="iconPack.FASEARCHPLUS" (click)="
                      openPopupCheck(JobPlanNumber, pmMWOText, 'jobPlanNumber')
                    " class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value="" #pmMWOText formControlName="jobPlanNumber" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isActivePMWOShow">
              <p>
                Active PM WO<span #ActivePMWO><fa-icon [icon]="iconPack.FASEARCHPLUS" (click)="
                      openPopupCheck(ActivePMWO, pmMWOText, 'activePMWO')
                    " class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value="" #pmMWOText [ngClass]="{'field-mandatory':activepmInputError}" formControlName="activePMWO" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isMWIShow">
              <p>
                MWI<span #MWI><fa-icon [icon]="iconPack.FASEARCHPLUS" (click)="openPopupCheck(MWI, mwiText, 'mwi')"
                    class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value="" #mwiText formControlName="mwi" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isEPLShow">
              <p>
                EPL Short<span #eplShort><fa-icon [icon]="iconPack.FASEARCHPLUS"
                    (click)="openPopupCheck(eplShort, eplShortText, 'epl')" class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value="" #eplShortText [ngClass]="{'field-mandatory':eplInputError}" formControlName="epl" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isEPLShow">
              <p>
                EPL Long<span #eplLong><fa-icon [icon]="iconPack.FASEARCHPLUS"
                    (click)="openPopupCheck(eplLong, eplLongText, 'epL_Long')" class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value=""  #eplLongText formControlName="epL_Long" (keydown)="OnKeyDown($event)" />
            </div>

            <div class="inputbox" *ngIf="isEPLShow">
              <p>
                Item<span #eplItem><fa-icon [icon]="iconPack.FASEARCHPLUS"
                    (click)="openPopupCheck(eplItem, eplItemText, 'item')" class="faIcon"></fa-icon></span>
              </p>
              <input type="text" value="" #eplItemText formControlName="item" (keydown)="OnKeyDown($event)" />
            </div>
          </div>
        </div>
      </form>

      <div class="actionSection">
        <div>
          <div *ngIf="searchType == 'JobPlan' || isEPLShow">
            <form class="k-form" [formGroup]="subSearchForm">
              <kendo-formfield orientation="horizontal">
                <ul class="k-radio-list k-list-horizontal">
                  <li class="k-radio-item">
                    <input type="radio" #resultsonly [value]="true" kendoRadioButton
                      formControlName="isExactResultsOnly" />
                    <kendo-label [for]="resultsonly" text="Exact results only"></kendo-label>
                  </li>
                  <li class="k-radio-item">
                    <input type="radio" #ShowMWOs [value]="false" kendoRadioButton
                      formControlName="isExactResultsOnly" />
                    <kendo-label [for]="ShowMWOs" text="Show MWOs with shared job plans"
                      *ngIf="searchType == 'JobPlan'"></kendo-label>
                    <kendo-label [for]="ShowMWOs" text="Show TAGs with shared EPLs" *ngIf="isEPLShow"></kendo-label>
                  </li>
                </ul>
              </kendo-formfield>
            </form>
          </div>
        </div>

        <div class="submitButton">
          <input type="submit" id="btn1" value="Search" class="searchBtn" (click)="search()" />
          <input type="button" id="btn2" value="Reset" class="resetBtn" (click)="resetClicked()" />
        </div>
      </div>
    </div>

    <div class="cardUi obseluteBlock h-80" *ngIf="isEPLShow">
      <div style="font-size: 18px">
        <span class="heading6">Obsolete Item(s)</span>
      </div>
      <div style="margin-top: 20px" class="obseluteBtnBlock">
        <button class="button-primary1" (click)="openDeletePopup()">
          Delete
        </button>
        <button class="button-primary1 ml-10" (click)="openReplacePopup()">
          Delete & Replace
        </button>
      </div>
      <div class="mt-10">
        <span class="linkObselute" (click)="openObselutePopup()">View Obsolete Items</span>
      </div>
    </div>
  </div>
</div>
<!-- [height]="gridHeight" -->
<div id="nonStyleGrid">
  <div class="searchTable">
    <kendo-grid [rowClass]="rowCallback" [kendoGridBinding]="searchData" [height]="gridHeight"
      [selectable]="{ enabled: true, checkboxOnly: true }" [(selectedKeys)]="selectedIndexIds" kendoGridSelectBy
      (selectionChange)="OnSelectionChangeEvent($event, 'mainGrid')" [pageSize]="300" [pageable]="isShowPagination">
      <kendo-grid-checkbox-column [width]="45" [resizable]="false" [columnMenu]="true" [columnMenu]="false"
        [showSelectAll]="true" class="customgrid"></kendo-grid-checkbox-column>
      <kendo-grid-column field="equipTagNumber" title="Equipment Tag Number" [width]="180" *ngIf="searchType != 'EPL'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'searchMatch': dataItem.isTagSearchMatch }">{{dataItem.equipTagNumber}}</span>
        </ng-template>

      </kendo-grid-column>
      <kendo-grid-column field="tag" title="Tag" [width]="180" *ngIf="searchType == 'EPL'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'searchMatch': dataItem.isTagSearchMatch }">{{dataItem.tag}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="headerRoute" title="Header/Route" [width]="150" *ngIf="searchType === 'PM'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'bold-text': dataItem.headerRoute == 'Header'}">{{ dataItem.headerRoute }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="frequency" title="Frequency" [width]="150"
        *ngIf="searchType === 'PM'"></kendo-grid-column>
      <kendo-grid-column field="serviceType" title="Service Type" [width]="150"
        *ngIf="searchType === 'PM'"></kendo-grid-column>
      <kendo-grid-column field="mwoNumber" title="MWO" [width]="150"
        *ngIf="searchType !== 'PM' && searchType !== 'EPL'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'searchMatch': dataItem.isMWOSearchMatch }">{{dataItem.mwoNumber}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="mwo" title="MWO" [width]="150" *ngIf="searchType == 'PM'"></kendo-grid-column>
      <kendo-grid-column field="mwoProblemDescription" title="MWO Problem Description" [width]="150"
        *ngIf="searchType !== 'EPL'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span
            [ngClass]="{'searchMatch': dataItem.isMwoProblemDescriptionSearchMatch }">{{dataItem.mwoProblemDescription}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="jobPlanNumber" title="Job Plan Number" [width]="180"
        *ngIf="searchType === 'JobPlan' || searchType === 'MWO'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'searchMatch': dataItem.isJobPlanNumberSearchMatch }">{{dataItem.jobPlanNumber}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" *ngIf="searchType === 'JobPlan'">
        <ng-template kendoGridCellTemplate let-dataitem>
          <span *ngIf="dataitem.hide_view" (click)="openGridPopup('jp-steps' ,dataitem)" class="viewSteps">View
            Steps</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [width]="100" *ngIf="searchType === 'JobPlan'">
        <ng-template kendoGridCellTemplate let-dataitem>
          <span *ngIf="dataitem.hide_view" (click)="openGridPopup('jp-parts' ,dataitem)" class="viewSteps">View
            Parts</span>
        </ng-template>
      </kendo-grid-column>

      <!-- EPL Columns -->
      <kendo-grid-column field="epL_Short_PLITM" title="EPL Short" *ngIf="searchType === 'EPL'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{
            'searchMatch': dataItem.isEplShortSearchMatch }">{{dataItem.epL_Short_PLITM}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="epL_Long_PLLITM" title="EPL Long" *ngIf="searchType === 'EPL'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{
            'searchMatch': dataItem.isEplLongSearchMatch }">{{dataItem.epL_Long_PLLITM}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="item" title="Item" [width]="150"
        *ngIf="searchType === 'EPL' && this.isSearchedByEplItem"></kendo-grid-column>
      <kendo-grid-column title="Details" *ngIf="searchType === 'EPL'">
        <ng-template kendoGridCellTemplate let-dataitem>
          <span class="viewSteps" (click)="openGridPopup('epl-details',dataitem)">Details</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="export" [width]="80">
        <ng-template kendoGridHeaderTemplate>
          <button class="exportbtnSearch" (click)="export()">Export</button>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoGridNoRecordsTemplate>
        <div class="norecordsmwobuild">No items to show...</div>
    </ng-template>
    </kendo-grid>
  </div>

  <div>
    <app-grid-mwo-error *ngIf="mwoErrorTextList.length > 0" [setGridData]="mwoErrorTextList"></app-grid-mwo-error>
    <p class="recordsummary">{{ searchData.length }} Result<span *ngIf="searchData.length>1 || searchData.length == 0 ">s </span>&nbsp;found</p>
  </div>

  <!-- Action Button Block -->
  <div class="updateEplBtn" *ngIf="searchType == 'EPL' && eplRadiButtonShow">
    <form class="k-form" [formGroup]="epl_JpRadioBtnUpdate">
      <kendo-formfield orientation="horizontal">
        <ul class="k-radio-list k-list-horizontal">
          <li class="k-radio-item">
            <input type="radio" #portrait kendoRadioButton [value]="true" formControlName="isCombined" />
            <kendo-label [for]="portrait" text="Combine TAGs into a single EPL"></kendo-label>
          </li>
          <li class="k-radio-item">
            <input type="radio" #landscape kendoRadioButton [value]="false" formControlName="isCombined" />
            <kendo-label [for]="landscape" text="Create unique EPL for each TAG"></kendo-label>
          </li>
        </ul>
      </kendo-formfield>
    </form>
  </div>
  <div class="updateEplBtn" *ngIf="searchType == 'JobPlan' && eplRadiButtonShow">
    <!-- <form class="k-form" [formGroup]="epl_JpRadioBtnUpdate"> -->
    <kendo-formfield orientation="horizontal">
      <ul class="k-radio-list k-list-horizontal">
        <li class="k-radio-item ">
          <input type="radio" #portrait kendoRadioButton id="portrait" [value]="true" [(ngModel)]="isCombine" />
          <kendo-label [for]="portrait" text="Combine MWOs into a single job plan"></kendo-label>
        </li>
        <li class="k-radio-item ">
          <input type="radio" #landscape kendoRadioButton [value]="false" id="landscape" [(ngModel)]="isCombine" />
          <kendo-label [for]="landscape" text="Create unique job plan for each MWO"></kendo-label>
        </li>
      </ul>
    </kendo-formfield>

    <!-- </form> -->
  </div>
  <div class="buttonList mt-20">
    <div class="btnLeft">
      <button class="button-backSearch" (click)="backBTNClicked()">
        <a class="backLink">Back</a>
      </button>
    </div>
    <div class="btnRight" *ngIf="
        searchType == 'JobPlan' || searchType == 'MWO' || searchType == 'PM'
      ">
      <button class="submitBtn" (click)="createCopyUpdate($event, 'create')">
        Create New {{ btnActionName }}
      </button>
      <button class="submitBtn" (click)="createCopyUpdate($event, 'copy')">
        Copy above {{ btnActionName }}
      </button>
      <button class="submitBtn" (click)="createCopyUpdate($event, 'update')">
        Update
      </button>
    </div>

    <div class="btnRight" *ngIf="searchType == 'EPL' && showAddEplBtn">
      <button class="submitBtn" (click)="validateEPL()">Add EPL</button>
    </div>

    <div class="btnRight" *ngIf="searchType == 'EPL' && showUpdateEplBtn">
      <button class="submitBtn" (click)="createCopyUpdate($event, 'update')">Update</button>
    </div>
  </div>
</div>

<!-- Popup Region -->
<kendo-popup [anchor]="anchorElement" [animate]="true" *ngIf="showBulkSearchPopup">
  <div class="wholepopup">
  <div class="popupDialogBulkSearch">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle">Bulk Search</span>
      <div href="#" class="popupClose" role="button" tabindex="0">
        <fa-icon [icon]="iconPack.FACLOSE" (click)="closePopup()" class="popupCLoseIcon"></fa-icon>
      </div>
    </div>
    <div class="popupContent">
      <div>
        <kendo-textarea class="popuptextBox" (valueChange)="onValueChange($event)" [value]="inputValue"
          [maxlength]="3500" [style.max-height.px]="180" placeholder="Paste text here.. (One entry per line )"
          id="bulksearchtextarea"></kendo-textarea>
      </div>
      <div class="popupFunctions">
        <kendo-label class="characterCount">Characters left : {{ counter
          }}<span *ngIf="!remainingCharacter"> reached limit</span></kendo-label>
        <button type="submit" class="primarybtn" (click)="popupSubmit()">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
</kendo-popup>

<kendo-popup [animate]="true" *ngIf="showDeletePopup" (clickOutside)="closePopup()">
  <div class="popupDialogEpl">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle">Delete obsolete items</span>
      <div href="#" class="popupCloseObs" role="button" tabindex="0">
        <fa-icon [icon]="iconPack.FACLOSE" (click)="closePopup()" class="popupCLoseIconEpl"></fa-icon>
      </div>
    </div>
    <div class="popupContentEpl">
      <div class="Itemcard">
        <div>
          <label class="Width2" for="">Item Number</label>
          <kendo-numerictextbox style="margin-right: 20px" (valueChange)="valueChangeDeleteTextbox($event)"
            class="textnumberinput" [value]="deleteTextboxValue" format="##" [min]="0"></kendo-numerictextbox>
          <input type="submit" value="Search" class="Button Is_Default ThemeGrid_Margin1"
            (click)="searchDeleteItem()" />
        </div>
      </div>
      <div class="VCenterDiv" style="margin-bottom: 30px; margin-top: 20px">
        <kendo-label [text]="deleteTextBox"></kendo-label>
      </div>

      <div class="popupBtn">
        <button (click)="deleteItem()"
          [ngClass]=" deleteSearchFound ? 'button-primary':'deletedisabled'">Delete</button>
        <button class="button-primary" (click)="closePopup()">Cancel</button>
      </div>
    </div>
  </div>
</kendo-popup>

<!-- <app-content-popup *ngIf="popupShow" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)">
  
    <div class="popupContentEpl">
      <div class="Itemcard">
        <div>
          <label class="Width2" for="">Item Number</label>
          <kendo-numerictextbox style="margin-right: 20px" (valueChange)="valueChangeDeleteTextbox($event)"
            class="textnumberinput" [value]="deleteTextboxValue" format="##" [min]="0"></kendo-numerictextbox>
          <input type="submit" value="Search" class="Button Is_Default ThemeGrid_Margin1"
            (click)="searchDeleteItem()" />
        </div>
      </div>
      <div class="VCenterDiv" style="margin-bottom: 30px; margin-top: 20px">
        <kendo-label [text]="deleteTextBox"></kendo-label>
      </div>

      <div class="popupBtn">
        <button (click)="deleteItem()" [ngClass]=" deleteSearchFound ? 'button-primary':'btn-disabled'">delete</button>
        <button class="button-primary" (click)="closePopup()">Cancel</button>
      </div>
    </div>
 
</app-content-popup> -->

<kendo-popup [animate]="true" *ngIf="showDeleteReplacePopup" (clickOutside)="closePopup()" class="deletereplacepopup">
  <div class="popupDialogEpl">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle">Delete and Replace obsolete items</span>
      <div href="#" class="popupCloseObs" role="button" tabindex="0">
        <fa-icon [icon]="iconPack.FACLOSE" (click)="closePopup()" class="popupCLoseIconEpl"></fa-icon>
      </div>
    </div>
    <div class="popupContentEpl">
      <div class="Itemcard">
        <div>
          <label class="Width2" for="">Item Number</label>
          <kendo-numerictextbox style="margin-right: 20px" (valueChange)="valueChangeDeleteTextbox($event)"
            class="textnumberinput" [value]="deleteTextboxValue" format="##" [min]="0"></kendo-numerictextbox>
          <input type="submit" value="Search" class="Button Is_Default ThemeGrid_Margin1"
            (click)="searchDeleteItem()" />
        </div>
      </div>
      <div class="VCenterDiv" style="margin-bottom: 10px; margin-top: 10px">
        <kendo-label [text]="deleteTextBox"></kendo-label>
      </div>
      <span *ngIf="deleteSearchFound"><b>Delete and Replace with :</b></span><br />
      <div class="gridTable" *ngIf="deleteSearchFound">
        <table class="group-table float-left" id='deletereplacetable' [class.onEdit]="isOnEdit">
          <thead>
            <tr>
              <th>Item <span class="mandatory">*</span></th>
              <th>Qty <span class="mandatory">*</span></th>
            </tr>
          </thead>
          <tbody *ngFor="let rowData of deleteReplaceGridData; let i=index">
            <tr class=" group-items  group-items-md" [class.selected]="i===selectedRowData" (click)="onEditItem(i)">
              <td>
                @if(isOnEdit && selectedRowData===i){
                <kendo-numerictextbox class="text-box" [ngClass]="{'error': rowData.error}" [(ngModel)]="rowData.item"
                  format="##" [min]="0"></kendo-numerictextbox>
                } @else {
                {{rowData.item}}
                }
                <kendo-formerror *ngIf="(rowData.itemerror && !rowData.isNewlyAdded)">Unknown Item</kendo-formerror>
                <kendo-formerror>{{rowData.error}}</kendo-formerror>
                
              </td>
              <!-- *ngIf="!rowData.isRowOnEdit" -->
              <td>
                @if(isOnEdit && selectedRowData===i){
                <kendo-numerictextbox class="text-box"
                  [ngClass]="{'error': (rowData.qty <= 0 && !rowData.isNewlyAdded)}" [(ngModel)]="rowData.qty"
                  format="##" [min]="0"></kendo-numerictextbox>
                } @else {
                {{rowData.qty}}
                }

                <kendo-formerror *ngIf="rowData.qty <= 0 && !rowData.isNewlyAdded">Quantity must be greater than
                  zero</kendo-formerror>
              </td>

            </tr>
            <tr class="group-items controls" *ngIf="i===selectedRowData">
              <td colspan="3" style="position: relative;">
                <div class="ControlActions">
                  <a class="SaveRowAction" (click)="submitItem(i)">
                    <fa-icon [icon]="iconPack.FACHECK" aria-hidden="true">
                    </fa-icon>
                  </a>
                  <a class="CancelRowAction" (click)="exitItem(i, rowData.id)">
                    <fa-icon [icon]="iconPack.FAXMARK" aria-hidden="true"></fa-icon>
                  </a>
                  <a class="DeleteRowAction" [ngClass]="{'btn-disabledicon': rowData.isNewlyAdded}"
                    (click)="deleteItemNumber(rowData.id)">
                    <fa-icon [icon]="iconPack.FATRASH" aria-hidden="true"></fa-icon>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3">
                <div class="create-new-sub links" (click)="addNewItem()">
                  <fa-icon [icon]="iconPack.FACIRCLEPLUS" aria-hidden="true"></fa-icon> Add Item
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="popupBtn">
        <button (click)="deleteAndReplace()"
                [ngClass]="isDeleteReplaceEnabled() ? 'button-primary' : 'deletedisabled'">
          Delete & Replace
        </button>
        <button class="button-primary" (click)="closePopup()">Cancel</button>
      </div>
    </div>
  </div>
</kendo-popup>


<app-content-popup *ngIf="popupShow" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)">
  <ng-container>
    <app-obselute-items-popup [setCRNo]="crNo"
      (closeContentPopUp)="closeActionPopup($event)"></app-obselute-items-popup>
  </ng-container>
</app-content-popup>

<app-content-popup *ngIf="isGridPopupOpened" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closeGridPopup()">
  <ng-container>
    <app-details-popup [setColumnConfig]="columnConfig" [setDetailsInput]="detailsInput"
      [setGridData]="gridPopupData"></app-details-popup>
  </ng-container>
</app-content-popup>
